module.exports = __webpack_public_path__ + "img/5T.4c281f99.png";